<ol class="breadcrumb">
  <li *ngFor="let item of model.items; let i=index" [class.active]="i==(model.items.length-1)">
    <a *ngIf="i<(model.items.length-1)" href="#">{{item.text}}</a>
    <ng-template [ngIf]="i==(model.items.length-1)">
      {{item.text}}
    </ng-template>
  </li>
</ol>
